import { connect } from 'react-redux';
import { getSupportPageKey } from 'js/reducers/app';
import ContextualSupport from './ContextualSupport';
import { getSupportVisibility } from 'js/reducers/app/selectors';
import { setContextualSupportVisibility } from 'js/actions/app/contextualSupportActions';

const mapStateToProps = (state) => {
  const supportPageKey = getSupportPageKey(state);
  const visible = getSupportVisibility(state);

  return {
    supportPageKey,
    visible,
  };
};

export default connect(mapStateToProps, {
  setSupportVisible: setContextualSupportVisibility,
})(ContextualSupport);
